import React from 'react';

const DataDeletion: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50 dark:bg-slate-900 py-12 px-4">
      <div className="max-w-3xl mx-auto bg-white dark:bg-slate-800 rounded-lg shadow-md p-8 md:p-12">
        <h1 className="text-3xl font-bold text-gray-900 dark:text-white mb-2">Exclusao de Dados</h1>
        <p className="text-sm text-gray-500 dark:text-gray-400 mb-8">Instrucoes para solicitacao de exclusao de dados pessoais</p>

        <div className="prose prose-gray dark:prose-invert max-w-none space-y-6 text-gray-700 dark:text-gray-300">

          <section>
            <h2 className="text-xl font-semibold text-gray-900 dark:text-white">Sua Solicitacao de Exclusao de Dados</h2>
            <p>
              Em conformidade com a Lei Geral de Protecao de Dados (LGPD - Lei 13.709/2018) e as
              politicas da Meta Platforms, voce pode solicitar a exclusao de seus dados pessoais
              armazenados na plataforma SinTicket.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 dark:text-white">Como Solicitar a Exclusao</h2>
            <p>Para solicitar a exclusao de seus dados, siga um dos procedimentos abaixo:</p>
            <ol className="list-decimal pl-6 space-y-3">
              <li>
                <strong>Atraves da plataforma (recomendado):</strong><br />
                Faca login na plataforma SinTicket, acesse Configuracoes {'>'} Minha Conta {'>'} Excluir Minha Conta.
                Siga as instrucoes na tela para confirmar a exclusao.
              </li>
              <li>
                <strong>Por email:</strong><br />
                Envie um email para <strong>suporte@sinticket.com.br</strong> com:
                <ul className="list-disc pl-6 mt-2">
                  <li>Assunto: "Solicitacao de Exclusao de Dados"</li>
                  <li>Seu nome completo</li>
                  <li>Seu endereco de email cadastrado</li>
                  <li>Uma declaracao expressa de que deseja excluir seus dados</li>
                </ul>
              </li>
            </ol>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 dark:text-white">Prazo de Resposta</h2>
            <p>
              Processaremos sua solicitacao dentro de <strong>15 dias uteis</strong> a partir do recebimento.
              Voce recebera uma confirmacao por email quando a exclusao for concluida.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 dark:text-white">Dados que Serao Excluidos</h2>
            <ul className="list-disc pl-6 space-y-2">
              <li>Seus dados de cadastro (nome, email)</li>
              <li>Suas configuracoes e preferencias</li>
              <li>Seus logs de atividade</li>
              <li>Dados de consentimento associados a sua conta</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 dark:text-white">Dados que Podem Ser Mantidos</h2>
            <p>Podemos manter certos dados quando exigido por lei ou para fins legitimos:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Dados necessarios para cumprimento de obrigacao legal ou regulatória</li>
              <li>Dados para prevencao de fraude e seguranca</li>
              <li>Registros de transacoes financeiras (conforme exigido pela legislacao fiscal)</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 dark:text-white">Dados Processados como Controlador vs Processador</h2>
            <p>
              A SinTicket atua como <strong>Controlador</strong> dos dados de seus proprios usuarios
              (funcionarios que utilizam a plataforma) e como <strong>Processador</strong> dos dados
              de contatos e clientes das empresas usuarias. Se voce e um contato/armazenado por uma
              empresa usuaria, entre em contato diretamente com essa empresa para exercer seus direitos.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 dark:text-white">Contato</h2>
            <p>
              Encarregado de Proteção de Dados (DPO):<br />
              Email: suporte@sinticket.com.br<br />
            </p>
          </section>

        </div>
      </div>
    </div>
  );
};

export default DataDeletion;
